import SocialShare from "./social-share";
export default SocialShare;
